import { getApiBaseUrl } from './apiBaseUrl';
import { getTokenForApp } from './CookieUtils';

const MID_KEY = 'hzc_mid';

export function rememberEngagementMid(messageId: string) {
  try {
    sessionStorage.setItem(MID_KEY, messageId);
  } catch (e) {
    // private mode
  }
}

export function readEngagementMid() {
  try {
    return sessionStorage.getItem(MID_KEY);
  } catch (e) {
    return null;
  }
}

export async function trackEngagement(body: {
  channel: string;
  event: string;
  campaignId?: string | null;
  messageId?: string | null;
  url?: string | null;
}) {
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  const token = getTokenForApp();
  if (token) headers.token = token;
  await fetch(`${getApiBaseUrl()}/e/t`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    keepalive: true,
  });
}
